const initialState = {
  success: null
};

const SuccessReducer = (state = initialState, action) => {
  if (action.type === 'SUCCESS') {
    return { ...state, success: action.success };
  } else {
    return state;
  }
};
export default SuccessReducer;
